import { render, staticRenderFns } from "./cas-panel.vue?vue&type=template&id=d160abea&"
import script from "./cas-panel.vue?vue&type=script&lang=js&"
export * from "./cas-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d160abea')) {
      api.createRecord('d160abea', component.options)
    } else {
      api.reload('d160abea', component.options)
    }
    module.hot.accept("./cas-panel.vue?vue&type=template&id=d160abea&", function () {
      api.rerender('d160abea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cascader/cas-panel.vue"
export default component.exports